import React from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router";

function NewExpensePolicy() {

  return (
     <Box sx={{width:"100%", height:"100%"}}>
        <Outlet/>
     </Box>
      
  );
}

export default NewExpensePolicy;
